import { DATE_TIME_FORMAT_REG_EXP } from "utils/datetime";

export const coPayFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    fieldType: "textfield",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Co-Pay Code",
    value: "",
    isRequired: true,
    maxChar: 50,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_\s\(\)]+$/,
    patternMessage: "Invalid code. Use letters, numbers, - or _",
  },
  {
    id: "policyItemId",
    label: "Policy Item",
    fieldType: "autocomplete",
    shownOnForm: true,
    width: "60%",
    isRequired: true,
    valueKey: "id",
    textValue: "label",
    onSearch: (query, deps) => {
      deps.onSearchPolicyItems(query);
    },
    options: (deps) => deps.policyItems || [],
    loading: (deps) => deps.policyItemsLoading,
    onInputChange: (searchValue, deps) => {
      if (deps.onSearchPolicyItems) {
        deps.onSearchPolicyItems(searchValue);
      }
    },
  },
  {
    id: "description",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Description",
    value: "",
    isRequired: true,
    fieldType: "textfield",
  },
  {
    id: "fixedAmountByBeneficiary",
    dataType: "number",
    shownOnForm: true,
    width: "60%",
    label: "Fixed Amount",
    value: 0,
    isRequired: true,
    fieldType: "textfield",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Status",
    value: "active",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ],
  },
  {
    id: "policyTypeIds",
    label: "Assigned Policy Types",
    fieldType: "dynamicList",
    shownOnForm: true,
    isRequired: false,
    columns: [
      {
        id: "policyTypeId",
        label: "Policy Type",
        type: "autocomplete",
        isRequired: true,
        optionsKey: "policyTypes", // Pulled from deps
        valueKey: "id",
        textValue: "label",
        composeLabel: (option) => `${option.name}`,
        width: 400,
        remoteUrl: "/api/policy-types/search-list", // New prop for independent fetching
        onSearch: (query, deps) => {
          deps.onSearchPolicyTypes(query);
        },
        options: (deps) => deps.policyTypes || [],
        loading: (deps) => deps.policyTypesLoading,
        onInputChange: (searchValue, deps) => {
          if (deps.onSearchPolicyTypes) {
            deps.onSearchPolicyTypes(searchValue);
          }
        },
      },
    ],
  },
  {
    id: "terminalIds",
    label: "Assigned Terminals",
    fieldType: "dynamicList",
    shownOnForm: true,
    isRequired: false,
    columns: [
      {
        id: "terminalId",
        label: "Terminal/Provider",
        type: "autocomplete",
        isRequired: true,
        optionsKey: "terminals", // Pulled from deps
        valueKey: "id",
        textValue: "label",
        composeLabel: (option) => `${option.code} ${option.hospitalName}`,
        width: 400,
        remoteUrl: "/api/terminals/search-list", // New prop for independent fetching
        onSearch: (query, deps) => {
          deps.onSearchTerminals(query);
        },
        options: (deps) => deps.terminals || [],
        loading: (deps) => deps.terminalsLoading,
        onInputChange: (searchValue, deps) => {
          if (deps.onSearchTerminals) {
            deps.onSearchTerminals(searchValue);
          }
        },
      },
    ],
  },
];

export const coPayRecord = {
  id: null,
  code: "",
  description: "",
  benefit: "",
  fixedAmountByBeneficiary: 0,
  status: "active",
  policyItemId: null,
  policyTypeIds: [],
  terminalIds: [],
};
